import * as React from "react";
import { connect } from "react-redux";
import NewWindow from "react-new-window";
import { ViewableFilesContext } from "@focus/services";
import { Button } from "@focus/focusUI";
import { FileBrowserNapeosContext, ProgramsContext, ProgramviewContext, ScenarioContext, ImageContext, withContext, } from "@focus/focusUI";
export class _ViewableFileButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = () => {
            this.setState(() => ({
                showPortal: true,
            }));
        };
        this.onClosewindow = () => {
            this.setState(() => ({
                showPortal: false,
            }));
        };
        this.state = {
            showPortal: false,
        };
    }
    portalContent() {
        if (this.state.showPortal) {
            const data = {
                fileName: this.props.fileName,
            };
            const url = "#/filecontent/?" + new URLSearchParams(data);
            return (React.createElement(NewWindow, { url: url, title: this.props.fileName, features: {
                    width: 800,
                    height: 1000,
                }, onUnload: this.onClosewindow }));
        }
        else {
            return null;
        }
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { icon: "eye-open", className: "view-button " + this.props.className, onClick: this.handleClick }, "View"),
            this.state.showPortal && this.portalContent()));
    }
}
const mapStateToProps = (state, { _programs, _programview, _scenario }) => ({
    scenario: _scenario.selectors.getSelectedScenarioName(state.scenarios),
    program: _programs.selectors.getSelectedProgram(state.programs),
    mode: _programview.selectors.getMode(state.programview),
});
const Connected = connect(mapStateToProps)(_ViewableFileButton);
const contextConfig = {
    _viewablefiles: ViewableFilesContext,
    _filebrowsernapeos: FileBrowserNapeosContext,
    _programs: ProgramsContext,
    _programview: ProgramviewContext,
    _scenario: ScenarioContext,
    _image: ImageContext,
};
export const ViewableFileButton = withContext(contextConfig)(Connected);
//# sourceMappingURL=ViewableFileButton.js.map